/* unplugin-vue-components disabled */import { render } from "./StereoscopicSectionExamEditor.vue?vue&type=template&id=5a9f3d0b&scoped=true"
import script from "./StereoscopicSectionExamEditor.vue?vue&type=script&lang=js"
export * from "./StereoscopicSectionExamEditor.vue?vue&type=script&lang=js"

import "./StereoscopicSectionExamEditor.vue?vue&type=style&index=0&id=5a9f3d0b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a9f3d0b"]])

export default __exports__